import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f5yy4uappq: FaireBrandEntity = {
  token: "b_f5yy4uappq",
  type: "brand",
  name: "WONDERXFANS",
  avatarUrl:
    "https://cdn.faire.com/fastly/0ce3730d9ec9a17f869b973e5f573f82aa7430c96daddb6cf3fe834676e5fa2c.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a657c9eebcdbe323816173ace116f0398914a820ce1406df7bdaf268eb1f30dd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0ce3730d9ec9a17f869b973e5f573f82aa7430c96daddb6cf3fe834676e5fa2c.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a657c9eebcdbe323816173ace116f0398914a820ce1406df7bdaf268eb1f30dd.jpeg",
  location: "Kirkland, WA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 44,
  isInsider: true,
  description:
    "We are WonderXfans\nYour one-stop shop for athleisure wholesale. We specialise in casual and activewear wholesale and offer a unique micro-wholesale factory-to-business experience for sellers - from solopreneurs to globally recognised brands.\nWONDERXFANS was created by entrepreneurs for entrepreneurs and endeavours to partner with brands that have quality and sustainability at their core.\nMeet Crissy\nWONDERXFANS founder, Crissy is comes from a family with generations of expertise in the fashion, textile, and clothing industries.Crissy studied at UC Santa Barbara and after graduation devoted her career to clothing production and design.An entrepreneur at heart, with clothing design and production flowing through her veins she created WONDERXFANS - a wholesale service focused on helping environmentally conscious brands bring quality to their customers.\nA Wholesaler Like No Other\nWe believe brands and wholesalers should work together to improve the supply ecosystem. The world deserves better. That's why WONDERXFANS offers a micro wholesale model.Small or no minimum order quantities (or Low MOQ) are better for small, independent businesses, and better for the environment. It’s a no-brainer.But that’s not the only reason brands come back to us again and again…",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:52.412Z",
    importedBy: "entity-db-cli",
  },
};
